import React from "react";
import { Typography } from "@material-ui/core";
import { Spinner } from "./Spinner";

export function LoadingWrapper(props) {
	return (
		<React.Fragment>
			{props.isLoading ? (
				<div className="loading-wrapper">
					<Spinner />
					<Typography variant="h6" style={{ marginTop: 10 }}>
						Loading...
					</Typography>
				</div>)
				: (
					<React.Fragment>
						{props.children}
					</React.Fragment>
				)}
		</React.Fragment>
	);
}
